const BYU_NAVY = "#002E5D";
const BYU_BLUE = "#0057B7";
const BYU_BG = "#F5F7FA";

const Contact = () => (
    <section
        className="py-5 d-flex flex-column"
        style={{
            flex: 1,
            display: "flex",
            minHeight: 0,
            background: BYU_BG,
        }}
    >
        <div className="container flex-grow-1 d-flex flex-column justify-content-center">
            <div className="row justify-content-center align-items-center">
                {/* Contact Info */}
                <div className="col-lg-5 mb-5 mb-lg-0">
                    <h2 style={{ color: BYU_NAVY, fontWeight: 700 }}>Contact Me</h2>
                    <p style={{ color: BYU_NAVY }}>
                        Interested in working together or have a question? Reach out and I'll get back to you soon!
                    </p>
                    <ul className="list-unstyled mb-4">
                        {/* <li className="mb-2">
                            <i className="bi bi-envelope-fill" style={{ color: BYU_BLUE, fontSize: 20, marginRight: 8 }}></i>
                            <a href="mailto:adamlawrencegriffin@gmail.com" style={{ color: BYU_NAVY, textDecoration: "none" }}>adamlawrencegriffin@gmail.com</a>                        </li> */}
                        <li className="mb-2">
                            <i className="bi bi-linkedin" style={{ color: BYU_BLUE, fontSize: 20, marginRight: 8 }}></i>
                            <a href="https://linkedin.com/in/adamgriffin1/" target="_blank" rel="noopener noreferrer" style={{ color: BYU_NAVY, textDecoration: "none" }}>LinkedIn</a>
                        </li>
                        <li className="mb-2">
                            <i className="bi bi-github" style={{ color: BYU_BLUE, fontSize: 20, marginRight: 8 }}></i>
                            <a href="https://github.com/adamlg1/" target="_blank" rel="noopener noreferrer" style={{ color: BYU_NAVY, textDecoration: "none" }}>GitHub</a>
                        </li>
                    </ul>
                </div>
                {/* Contact Form */}
                <div className="col-lg-7">
                    <div className="card shadow-sm border-0" style={{ borderRadius: 16 }}>
                        <div className="card-body p-4">
                            <form
                                action="https://formspree.io/f/mzzvgkdn" // <-- Replace with your Formspree form ID
                                method="POST"
                            >
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label" style={{ color: BYU_NAVY }}>Name</label>
                                    <input type="text" className="form-control" id="name" name="name" placeholder="Your Name" required />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label" style={{ color: BYU_NAVY }}>Email</label>
                                    <input type="email" className="form-control" id="email" name="email" placeholder="you@email.com" required />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="message" className="form-label" style={{ color: BYU_NAVY }}>Message</label>
                                    <textarea className="form-control" id="message" name="message" rows={5} placeholder="Type your message..." required />
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary px-4"
                                    style={{ background: BYU_NAVY, borderColor: BYU_NAVY, borderRadius: 12, fontWeight: 600 }}
                                >
                                    Send Message
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Contact;